
/**
 * How to use this component?
 *
 * <DragAndDropFile v-model="variable" />
 *
 * More details: read the props comments below
 */
export default {
    name: "DragAndDropFile",
    props: {
        // eslint-disable-next-line vue/require-prop-types
        image: {
            default: () => {},
        },
        // eslint-disable-next-line vue/require-prop-types
        value: {
            default: () => {},
        },
        // ? This is the showing image, after drop or select the image file
        size: {
            type: String,
            default: null,
        },
        label: {
            type: String,
            default: null,
        },
        // ? Width and height are the expected image size, and showing in recommended size
        width: {
            type: Number,
            default: 0,
        },
        height: {
            type: Number,
            default: 0,
        },
        // ? check is used for checking if the image is matched to the width and height
        check: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            dragover: false,
            uploadedFiles: [],
            selectImage: null,
            imageUrl: null,
            fileImage: null,
            imageIsRequired: false,
            validationError: null,
            warningErrorColor: true,
            enableToShowImage: false, // This status is used for displaying the image, in case the image is wrong sizes the image won't be displayed,
            isPdfFile: false, // This status is used for checking PDF, in case the file is PDF, the component shouldn't display file in <img />
        };
    },
    computed: {
        rules() {
            return [
                (v) => {
                    if (!this.required) {
                        return true;
                    }
                    if (!v) {
                        this.imageIsRequired = true;
                        return "is required";
                    } else {
                        return true;
                    }
                },
            ];
        },
    },
    watch: {
        value(value) {
            if (!value) {
                this.imageUrl = null;
                this.selectImage = null;
            }
        },
    },
    methods: {
        removeFile() {
            this.uploadedFiles = [];
            this.imageUrl = null;
            this.selectImage = null;
            this.fileImage = null;
            this.warningErrorColor = true;
            this.$emit("input", "");
        },
        onDrop(e, type = "drag") {
            this.dragover = false;
            this.warningErrorColor = true;
            const fileType =
                type === "drag" ? e.dataTransfer.files[0].type : e.type;

            this.isPdfFile = fileType === "application/pdf";

            this.validationError = null;
            if (
                fileType !== "image/jpeg" &&
                fileType !== "image/png" &&
                fileType !== "image/jpg" &&
                fileType !== "image/jpeg" &&
                fileType !== "image/webp" &&
                fileType !== "application/pdf"
            ) {
                this.validationError =
                    "Please select file png, jpg, jpeg, webp, pdf";
                return false;
            } else {
                this.validationError = null;
            }

            let fileCheck = null;
            if (type === "select") {
                fileCheck = e;
            } else {
                // If there are already uploaded files remove them
                if (this.uploadedFiles.length > 0) this.uploadedFiles = [];
                fileCheck = e.dataTransfer.files[0];
            }

            if ((fileCheck.size / 1000000).toFixed(3) > 10) {
                this.validationError = "File size must less than 10MB";
                return false;
            }

            if (type === "select") {
                this.selectImage = e;
                this.$emit("input", e);
                this.onCheckImageSize(e);
            } else {
                // If there are already uploaded files remove them
                if (this.uploadedFiles.length > 0) this.uploadedFiles = [];
                this.selectImage = e.dataTransfer.files[0];
                this.$emit("input", e.dataTransfer.files[0]);
                this.onCheckImageSize(e.dataTransfer.files[0]);
            }
        },
        previewImage() {
            if (this.selectImage) {
                this.imageUrl = URL.createObjectURL(this.selectImage);
            }
        },
        // to browse image file
        selectFile() {
            this.warningErrorColor = true;
            if (!this.enableToShowImage) {
                this.selectImage = null;
            }
            if (!this.selectImage) {
                this.$refs.uploader.$refs.input.click();
            }
        },
        fileInputChange(e) {
            if (e) {
                this.onDrop(e, "select");
            }
        },
        onCheckImageSize(imageFile) {
            this.previewImage();
            if (!this.check) return;

            const reader = new FileReader();
            const imgSize = new Image();
            reader.readAsDataURL(imageFile);

            reader.onload = (evt) => {
                imgSize.onload = () => {
                    if (
                        imgSize.height !== this.height &&
                        imgSize.width !== this.width
                    ) {
                        this.validationError = `Expected Size ${this.width} x ${this.height} pixel.`;

                        this.warningErrorColor = true;
                        this.enableToShowImage = false;
                        return true;
                    } else {
                        this.validationError = null;
                        this.enableToShowImage = true;
                        return false;
                    }
                };
                imgSize.src = evt.target.result;
            };
        },
    },
};
